import React, { useState } from 'react';
import { Icon } from '@iconify/react';

const StarRating = ({ onChange, initialRating = 0, totalStars = 5 }) => {
  const [rating, setRating] = useState(initialRating);

  const handleClick = (selectedRating) => {
    setRating(selectedRating);
    if (onChange) {
      onChange(selectedRating);
    }
  };

  return (
    <div className="flex items-center gap-1">
      {[...Array(totalStars)].map((_, index) => {
        const starValue = index + 1;
        return (
          <button
            key={index}
            type="button"
            className="p-1 focus:outline-none"
            onClick={() => handleClick(starValue)}
          >
            <Icon
              icon="ic:round-star"
              width="30"
              className={`transition-colors duration-200 ${
                (rating) >= starValue
                  ? 'fill-yellow-400 text-yellow-400'
                  : 'fill-transparent text-gray-300'
              }`}
            />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;